<template>
  <div class="build-team">
    <el-page-header @back="$router.go(-1)" content="团队组建"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="测评问卷" name="1" lazy>
        <Questionnaire />
      </el-tab-pane>
      <el-tab-pane label="测评结果" name="2" lazy>
        <Teams />
      </el-tab-pane>
      <el-tab-pane label="定岗" name="3" lazy>
        <PostInfo />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PostInfo from "./postInfo.vue";
import Questionnaire from "./questionnaire.vue";
import Teams from "./teams.vue";
export default {
  components: { Teams, Questionnaire, PostInfo },
  data() {
    return {
      activeName: "1",
    };
  },
};
</script>

<style lang="less" scoped>
.build-team {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>